
<template>
<div>
  <div v-if="!isLoading" class="">
    <div v-if="item" class="">
      <div class="row">
        <div class="col-12"> 
          <div class="card mb-5">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Invitation status</h5>
              <div class="dropdown dropstart no-arrow">
                <button class="dropdown-toggle btn btn-sm btn-light" type="button"
                  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ri-more-2-fill"></i>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <button @click="generateSlip()" class="dropdown-item"
                    type="button" >
                    Print invitation slip</button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-body position-relative">
              <div  class="row g-4"> 
                <div class="col-sm-6">
                  <label class="small text-muted">Status</label>
                  <p class="mb-0"><span v-html="statusBadge(item.status)"></span></p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Invitation was sent on</label>
                  <p class="mb-0">{{ $filters.date(item.created_at,1) }}</p>
                </div>
                <div class="col-sm-6">
                  <div v-if="item.status == 'accepted_interview'">
                    <label class="small text-muted">Accepted on</label>
                    <p class="mb-0">{{ $filters.date(item.accepted_at, 1) }}</p>
                  </div>
                  <div v-if="item.status == 'rejected_interview'">
                    <label class="small text-muted">Rejected on</label>
                    <p class="mb-0">{{ $filters.date(item.rejected_at, 1) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.status === 'pending_acceptance'" class="bd-callout mt-0 mb-5 bd-callout-warning">
            <accept-interview-form
            :edit-item="item"
            @updateItem="updateItem($event)"/>
          </div>
          <div v-else class="bd-callout mt-0 mb-5 bd-callout-info">
            <h4>Your Invitation Slip. </h4>
            <div class="pt-4">
              <p class="mb-1">
                You can download this invitation slip and present it to your employer as proof of your invitation. 
              </p>
              <div class="mt-3">
                <button @click="generateSlip()" class="btn btn-primary"  type="button" >Print invitation slip</button>
              </div>
            </div>
          </div>
          <div v-if="item.interview && item.interview.start_at">
            <count-down-timer :deadline="item.interview.start_at"
                title="Interview Scheduled Start Time" body-class="mb-5" />
          </div>
          <div v-if="item.interview" class="card mb-5 overflow-hidden">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Interview Details</h5>
            </div>
            <div class="card-body">
              <div class="row g-3 g-lg-4">
                <div class="col-lg-6">
                  <label class="small text-muted">Interview ID</label>
                  <p class="mb-0">{{ item.interview.friendly_id }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Title</label>
                  <p class="mb-0">{{item.interview.title}}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Contact Phone Number</label>
                  <p class="mb-0">{{item.interview.mobile}}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Contact Email</label>
                  <p class="mb-0">{{item.interview.email}}</p>
                </div>
                <div class="col-sm-6">
                  <label class="mb-0 text-muted">Scheduled Date and Time</label>
                  <p class="mb-0 mt-2 pt-1">{{ $filters.formatSchedulePeriod(item.interview.start_at, item.interview.end_at) }}</p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Location/Venue </label>
                  <CommonAddress :item="item.interview" />
                </div>
                <div class="col-12">
                  <label class="small text-muted">Description</label>
                  <div v-html="preText(item.interview.description)" class="mb-0"></div>
                </div>
                <div v-if="item.interview.closed_at" class="col-sm-6">
                  <label class="mb-0 text-muted">Closed at</label>
                  <p class="mb-0 mt-2 pt-1 text-muted">{{ $filters.date(item.interview.closed_at, 1) }}</p>
                </div>
                <div v-if="item.interview.canceled_at" class="col-sm-6">
                  <label class="mb-0 text-muted">Canceled at</label>
                  <p class="mb-0 mt-2 pt-1 text-muted">{{ $filters.date(item.interview.canceled_at, 1) }}</p>
                </div>
              </div>          
            </div>
          </div>
          <div v-if="item.opportunity">
            <opportunity-detail-card  :item="item.opportunity" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <is-loading v-else />
</div>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue'
import OpportunityDetailCard from '@/components/cards/OpportunityDetailCard.vue'
import AcceptInterviewForm from '@/components/forms/AcceptInterviewForm.vue'
import CountDownTimer from '@/components/widgets/CountDownTimer.vue';

export default {
  name: "interview-show",
  components:{
    IsLoading,
    OpportunityDetailCard,
    AcceptInterviewForm,
    CountDownTimer
  },
  data() {
    return {
      isLoading: true,
      popupModalShow: false,
      item: null,
    }
  },
  watch: {
    '$route.params.invitationId': function (id){
      if(id) this.fetchItem()
    },
  },
  methods: {
    updateItem(item){
      this.item = Object.assign(this.item, item);
    },
    fetchItem(){
      this.isLoading = true
      this.$http.get(`/interview-invitations/${this.$route.params.invitationId}/show`)
      .then((response) => {
        this.isLoading = false
        if(response.data.success){
          this.item = response.data.data
        }else{
          this.$router.push({path: '/error-404'})
        }
      })
    },
    generateSlip(){
      const payload = {
        url: `/interview-invitations/${this.item.id}/slip`,
        data: {}
      }
      this.$store.dispatch("changeLoaderValue", true)
      this.pdfFileExport(payload)
        .then((response) => {
          this.$store.dispatch("changeLoaderValue", false)
        }).catch((error) => {
          this.$store.dispatch("changeLoaderValue", false)
        })
    },
    initializeAll(){
      this.popupModalShow = false;
    }
  },
  created(){
    this.fetchItem()
  },
}

</script>

